module.exports = __webpack_public_path__ + "img/2.1cfc288a.png";